import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { FC } from "react";

export type TitleBarProps = {
  onClick?: Function;
};

export const CloseButton: FC<TitleBarProps> = ({ onClick }) => {
  return (
    <IconButton
      className="custom-icon-button"
      size="medium"
      id={`request-edit-close`}
      aria-label={`request-edit-close`}
      onClick={() => onClick && onClick()}
    >
      <CloseIcon />
    </IconButton>
  );
};
